import { dcpcApi } from './dcpcApi';

const CONFINES_TAG = 'Confines';

dcpcApi.enhanceEndpoints({ addTagTypes: [CONFINES_TAG] });

const confinesApi = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({
    getConfines: builder.query({
      query: (stationId) => `meteocode-confines/stations/${stationId}`,
      providesTags: [CONFINES_TAG],
    }),
    getConfine: builder.query({
      query: ({ stationId, code }) => `/meteocode-confines/stations/${stationId}/meteo-code/${code}`,
      providesTags: [CONFINES_TAG],
    }),
    getConfineUnique: builder.query({
      query: ({ stationId, code }) => `/meteocode-confines/stations/${stationId}/meteo-code/${code}/unique`,
      providesTags: [CONFINES_TAG],
    }),
    updateCofine: builder.mutation({
      query: ({ stationId, code, body }) => ({
        url: `/meteocode-confines/stations/${stationId}/meteo-code/${code}`,
        method: 'POST',
        body,
      }),
      invalidatesTags: [CONFINES_TAG],
    }),
    deleteCofine: builder.mutation({
      query: ({ stationId, code }) => ({
        url: `/meteocode-confines/stations/${stationId}/meteo-code/${code}`,
        method: 'DELETE',
      }),
      invalidatesTags: [CONFINES_TAG],
    }),
  }),
});

export const {
  useGetConfinesQuery,
  useGetConfineQuery,
  useGetConfineUniqueQuery,
  useUpdateCofineMutation,
  useDeleteCofineMutation,
} = confinesApi;
